// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingInfoAddModal_wrap__1IBS7","pure":"ShippingInfoAddModal_pure__iMrr+","button":"ShippingInfoAddModal_button__LAHOh"};